import axios from 'axios'
import { isError } from './api'

// OEmbed providers https://oembed.com/providers.json

const providers = [
  {
    name: 'youtube',
    getUrl: (url) => `https://www.youtube.com/oembed?url=${url}&format=json`,
    matches: [
      /^https:\/\/(www\.)?youtube\.com\/watch\?v=(.)*/,
      /^https:\/\/(www\.)?youtube\.com\/v\/(.)*/,
      /^https:\/\/youtu\.be\/(.)*/,
      /^https:\/\/(www\.)?youtube\.com\/playlist\?list=(.)*/,
      /^https:\/\/(www\.)?youtube\.com\/shorts\/(.)*/
    ]
  },
  {
    name: 'vimeo',
    getUrl: (url) => `https://vimeo.com/api/oembed.json?url=${url}`,
    matches: [
      /^https:\/\/vimeo\.com\/(.)*/,
      /^https:\/\/vimeo\.com\/album\/(.)*/,
      /^https:\/\/vimeo\.com\/channels\/(.)*/,
      /^https:\/\/vimeo\.com\/groups\/(.)*/,
      /^https:\/\/vimeo\.com\/ondemand\/(.)*/,
      /^https:\/\/player\.vimeo\.com\/video\/(.)*/
    ]
  }
]

export const getOEmbedUrl = (url) => {
  for (const provider of providers) {
    for (const matcher of provider.matches) {
      if (url.match(matcher)) return provider.getUrl(url)
    }
  }
  return null
}

export const getOEmbedHtml = async (url) => {
  const response = await axios.get(url).catch(e => e.response)
  const successfulRequest = !isError(response.status)
  if (successfulRequest) {
    const elem = new DOMParser().parseFromString(response.data.html, 'text/html')
    const iframe = elem.querySelector('iframe')
    iframe.setAttribute('height', '100%')
    iframe.setAttribute('width', '100%')
    return iframe.outerHTML
  } else return null
}
